import CountrySelector from "./CountrySelector";

import {createElement, memoize} from "../util/utils";
import Dropdown from "bootstrap/js/src/dropdown";

export default class DistributorList {
  constructor(button) {
    if('true' === button.dataset.distrubutorList) {
      return;
    }
    button.dataset.distrubutorList = 'true';
    this.dropdown = Dropdown.getInstance(button);
    this.$variationForm = $('.variations_form');
    this.wrapper = button.closest('.dropdown');
    this.menu = this.wrapper ? this.wrapper.querySelector('.dropdown-shopnow') : null;
    this.list = this.menu ? this.menu.querySelector('.distributors-dropdown-list') : null;
    this.countrySelector = this.wrapper ? this.wrapper.querySelector('.btn-country-selector') : null;
    this.notFound =  this.wrapper ? this.wrapper.querySelector('.no-distributors-text') : null;
    this.distributorsItems = [];
    this.currentCountry = this.countrySelector ? this.countrySelector.dataset.currentCountry : null;
    this.isSwitcherEnabled = this.countrySelector ? this.countrySelector.dataset.switcher !== 'no' : false;

    try {
      this.defaultDistributors = JSON.parse(button.dataset.distributors);
    } catch (e) {
      this.defaultDistributors = null;
    }

    try {
      this.defaultCountries = JSON.parse(this.countrySelector.dataset.countries);
    } catch (e) {
      this.defaultCountries = null;
    }

    this.currentCountries = this.defaultCountries;

    this.maybeShowCountrySelector(this.defaultCountries);

    this.setDistributorsList(this.defaultDistributors);

    this.attachHandlers();
  }

  attachHandlers()
  {
    if(this.countrySelector) {
      this.countrySelector.addEventListener('click', this.onCountrySelectorClick);
    }

    if(this.$variationForm.length > 0) {
      this.$variationForm.on('found_variation', this.onFoundVariation);
    }
  }

  maybeShowCountrySelector = countries => {
    if(!this.isSwitcherEnabled || !countries) {
      return;
    }

    if('object' === typeof countries && Object.keys(countries).length > 1 || ( 1 === Object.keys(countries).length && ! Object.keys(countries).includes(this.currentCountry) ) ) {
      this.menu.classList.add('with-country-selector')
    } else {
      this.menu.classList.remove('with-country-selector')
    }
  }

  setMenuState(state = 'default')
  {
    if(!this.menu) {
      return;
    }

    switch (state) {
      case 'loading':
        this.menu.classList.remove('with-distributors');
        this.menu.classList.add('loading');
        break;
      case 'with-distributors':
        this.menu.classList.remove('loading');
        this.menu.classList.add('with-distributors');
        break;
      case 'default':
      default:
        this.menu.classList.remove('loading', 'with-distributors');
    }
  }

  setDistributorsList = distributors => {

    if(this.distributorsItems.length > 0) {
      this.distributorsItems.forEach(item => item.remove());
    }

    if(!distributors || !Array.isArray(distributors)) {
      this.setMenuState();
      this.notFoundMessage(true);
      return;
    }

    let currentCountryItems = false;

    if(distributors.length > 0) {
      distributors.forEach(distributor => {
        const { country, link, title } = distributor;
        let item = createElement({
          tagname: 'li',
          classes: ['distributor-item'],
          dataset: {
            country: country,
          },
          parent: this.list,
        });

        if(country !== this.currentCountry) {
          item.style.display = 'none';
        } else {
          currentCountryItems = true;
        }

        createElement({
          tagname: 'a',
          classes: ['dropdown-item', 'px-23', 'py-12', 'fw-light'],
          attributes: {
            href: link,
            target: '_blank',
            rel: 'nofollow',
          },
          textContent: title,
          parent: item,
        });

        this.distributorsItems.push(item);
      });
    }
    this.notFoundMessage(!currentCountryItems);
    this.setMenuState('with-distributors');
  }

  showSelectedItems(selectedCountry)
  {
    let foundItems = false;
    if(this.distributorsItems && this.distributorsItems.length > 0) {

      this.distributorsItems.forEach(item => {
        if(selectedCountry === item.dataset.country) {
          item.removeAttribute('style');
          foundItems = true;
        } else {
          item.style.display = 'none';
        }
      });
    }

    this.notFoundMessage(!foundItems);
  }

  onCountryChange = data => {
    if(!data || undefined === data.code) {
      this.currentCountry = palram.default_country_code;
      return;
    }

    this.currentCountry = data.code;

    //Update country name
    const nameEl = this.wrapper.querySelector('.country-name');
    if(nameEl) {
      nameEl.textContent = data.name || '';
    }

    this.showSelectedItems(data.code);
    this.maybeShowCountrySelector(this.currentCountries);
    if(this.dropdown) {
      this.dropdown.update();
    }
  }

  onCountrySelectorClick = event => {

    if(!this.currentCountries) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();

    const selector = new CountrySelector({
      dropdown: this.dropdown,
    });


    selector.open({
      countries: this.currentCountries,
      selected: this.currentCountry,
      onCountryChange: this.onCountryChange,
    });
  }

  onFoundVariation = async (event, variation) => {
    if(undefined !== variation.sku && '' !== variation.sku) {
      this.setMenuState('loading');
      let response = await this.getCachedData(variation.sku);
      if( response.success ) {
        const { distributors, countries } = response.data;
        this.currentCountries = countries;
        this.setDistributorsList(distributors);
        this.maybeShowCountrySelector(countries);
      } else {
        this.setMenuState('default');
        this.currentCountries = null;
        this.currentCountry = palram.default_country_code;
      }
    }
  }

  notFoundMessage(show = true) {
    console.log(this.notFound)
    if(!this.notFound) {
      return;
    }

    if(show) {
      this.wrapper.classList.add('no-distributors-found');
      this.notFound.removeAttribute('style');
    } else {
      this.wrapper.classList.remove('no-distributors-found');
      this.notFound.style.display = 'none';
    }
  }

  async getDistributors(sku) {
    return $.ajax({
      url: palram.ajax_url,
      data: {
        sku,
        secure: palram.nonces.get_distributors,
        action: 'palram_get_distributors',
      },
      type: 'GET',
    });
  }

  getCachedData = memoize(this.getDistributors)
}
